module.exports = __webpack_public_path__ + "img/1436551976.b0e817fe.jpg";